// src/components/OrganizationSchema.tsx
import React, { FC } from 'react';
import Head from 'next/head';

const OrganizationSchema: FC = () => {
  const organizationData = {
    "@context": "https://schema.org/",
    "@type": "Organization",
    "name": "CarPlanner",
    "url": "https://www.carplanner.com/",
    "logo": "https://static1.carplanner.com/logos/carplanner.svg",
    "description": "CarPlanner offre soluzioni di noleggio auto a lungo termine per privati e aziende in tutta Italia.",
    "sameAs": [
      "https://www.facebook.com/carplannercom",
      "https://www.linkedin.com/company/carplanner",
      "https://twitter.com/CarPlannerIT"
    ]
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationData) }}
      />
    </Head>
  );
};

export default OrganizationSchema;
